module.exports = __webpack_public_path__ + "media/common/fonts/template/template-5b2b5e080d5e2cfeaaefb148d27abeaf.woff";